import { useEffect } from 'react';
import { Button } from '@lyse-as/formds-react';
import { ArrowBackIcon } from '@lyse-as/formds-react/lib/icon/common';
import { useTranslation } from 'react-i18next';

import { Typography } from 'app/component-library-wave';
import { useAppSelector } from 'app/hooks/redux-thunk';
import { getGtmFullUrl, GtmErrorType } from 'app/utils/gtm-tracking-utils';
import { getDataLayers } from 'app/utils/trackingService';
import { navigationService } from 'app/service/navigation/navigation-service';

import styles from './invoice-postpone.module.scss';

export const RejectedPostpone = () => {
  const { errorCode, errorCodeShortHand } = useAppSelector((state) => state.invoice.postponeState);
  const { t } = useTranslation();

  const handleBack = () => {
    history.back();
  };

  useEffect(() => {
    const errorMessageEvent = {
      error_type: GtmErrorType.INVOICE_ERROR,
      error_content: `INVOICE_POSTPONE_REJECTED ${errorCode} ${errorCodeShortHand}`,
      page_url: getGtmFullUrl(navigationService.PAGES.invoicePostpone.url),
      error_area: '',
    };
    getDataLayers().customEvents.pushErrorMessageEvent(errorMessageEvent);
  }, []);

  return (
    <>
      <Typography component="h1" variant="formds-altibox-subtitle-primary" bold={true}>
        {t('pages.invoice.invoiceErrors.name')}
      </Typography>
      <div className={styles.messageContainer}>
        <Typography component="p" variant="formds-body">
          {t(`pages.invoice.invoiceErrors.DYNAMIC_KEYS.${errorCode}`)}
        </Typography>
      </div>
      <div className={styles.buttonContainer}>
        <Button variant="outlined" scheme="primary" onClick={handleBack} style={{ width: '100%' }}>
          <ArrowBackIcon />
          {t('pages.invoice.invoicePostpone.back')}
        </Button>
      </div>
    </>
  );
};
